import React from 'react';
import isNumber from 'lodash/isNumber';
import map from 'lodash/map';
import reduce from 'lodash/reduce';
import keys from 'lodash/keys';
import {toPriceStr, tryGet} from './utils';

import './table.css';

const RecursiveTable = ({data, columns}) => {
  return <div id='reportTable'>
    <table>
      <tbody>
        {
          map(keys(data), (vehicle, indexVehicle) =>
            map(data[vehicle], (delivery, indexDelivery) =>
              map(delivery.slotData, (slot, indexSlot) =>

              <>
                {!indexDelivery && !indexSlot &&
                <tr className='header'>
                  <th>Veículo</th>
                  <th>Pré Carga</th>
                  <th>Data</th>
                  {map(columns, (column, i) => (<th key={i}>{column.label}</th>))}
                </tr>
                }

                <tr key={indexVehicle + indexDelivery + indexSlot}>

                  {!indexDelivery && !indexSlot &&
                  <td rowSpan={reduce(data[vehicle], (acc, el) => acc + el.slotData.length, 0)}>
                    {vehicle}
                  </td>
                  }
                  {!indexSlot &&
                    <>
                      <td rowSpan={delivery.slotData.length}>
                        {delivery._id}
                      </td>
                      <td rowSpan={delivery.slotData.length}>
                        {delivery.calendarT}
                      </td>
                    </>
                  }

                  {map(columns, (column, columnIndex) =>
                    <td key={indexVehicle + indexDelivery + indexSlot + column.dataKey}>
                      {
                        column.dataKey === 'value' && isNumber(tryGet(slot, [column.dataKey]))
                          ? toPriceStr(tryGet(slot, [column.dataKey]))
                          : tryGet(slot, [column.dataKey])
                      }
                    </td>
                  )}

                </tr>
              </>
              )
            )
          )
        }
      </tbody>
    </table>
  </div>;
};

export const blankTable = {
  title: '',
  data: {}
};

export default RecursiveTable;
